import {useInfiniteQuery} from "@tanstack/react-query";
import {technicianApi} from "../services/technicianService";

export const useFetchPrestataires = ({
  size,
  filter,
  order,
  search,
  enabled = true,
}) => {
  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: [
      "prestataires",
      size,
      JSON.stringify(filter),
      JSON.stringify(order),
      search,
    ],
    queryFn: ({pageParam = 0, signal}) =>
      technicianApi.getAll({
        size,
        filter,
        order,
        page: pageParam,
        search,
        signal,
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const morePagesExist = lastPage?.currentPage < lastPage?.totalPages - 1;
      if (!morePagesExist) return undefined;
      return allPages.length; // The next page index
    },
    select: (data) => {
      const flattenedData = {
        ...data,
        pages: data.pages.flatMap((page) => page.rows),
      };
      return flattenedData;
    },
    staleTime: 30000,
    enabled,
  });

  return {
    prestataires: data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    refetch,
  };
};
